module.exports = __webpack_public_path__ + "img/hk.hk99b4131.svg";